module.exports = __webpack_public_path__ + "img/tape-icon.f1c7d1a2.svg";